import api from '@/utils/axios'

// 发送邮件
export const sendEmail = (body) => {
  return api.post(`/rest/email/send_mail`, body)
}
export const creatDomain = (body) => {
  return api.post(`/rest/doamin/create`, body)
}
export const freeLic = (body) => {
  return api.post('/free_lic_req', body)
}



// WEBPACK FOOTER //
// ./src/api/list/apiList.js